import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import { useTranslation } from 'react-i18next';
import Highlight from '../components/Highlight';

const steps = [
  { number: '01', icon: 'ri-earth-line', key: 'step1' },
  { number: '02', icon: 'ri-car-line', key: 'step2' },
  { number: '03', icon: 'ri-calendar-line', key: 'step3' },
  { number: '04', icon: 'ri-secure-payment-line', key: 'step4' },
  { number: '05', icon: 'ri-mail-send-line', key: 'step5' },
];

// Display order maps to these FAQ key numbers.
const faqOrder = [1, 4, 2, 5, 3, 6];

export default function HowItWorksPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-surface">
        <div className="mx-auto max-w-5xl px-5 py-12 md:py-20">
          <div className="text-center mb-14 md:mb-20">
            <h1 className="text-[28px] font-bold leading-tight tracking-tight md:text-[42px]">
              <Highlight text={t('howItWorksPage.title')} />
            </h1>
            <p className="mt-4 mx-auto max-w-xl text-[15px] md:text-[16px] leading-relaxed text-muted">
              {t('howItWorksPage.subtitle')}
            </p>
          </div>

          <div className="space-y-12 md:space-y-20">
            {steps.map((step, idx) => (
              <div
                key={step.number}
                className={`flex flex-col gap-6 md:flex-row md:items-start md:gap-10 ${
                  idx % 2 === 1 ? 'md:flex-row-reverse' : ''
                }`}
              >
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary/10 text-[13px] font-bold text-primary">
                      {step.number}
                    </span>
                    <h2 className="text-[18px] font-semibold text-ink md:text-[20px]">
                      {t(`howItWorksPage.${step.key}.title`)}
                    </h2>
                  </div>
                  <p className="text-[15px] leading-relaxed text-muted mb-4">
                    {t(`howItWorksPage.${step.key}.description`)}
                  </p>
                  <ul className="space-y-2">
                    {[1, 2, 3].map((n) => (
                      <li
                        key={n}
                        className="flex items-start gap-2 text-[14px] text-muted"
                      >
                        <i className="ri-check-line mt-0.5 w-4 h-4 flex items-center justify-center text-primary shrink-0" />
                        {t(`howItWorksPage.${step.key}.feature${n}`)}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="flex shrink-0 items-center justify-center md:w-[320px]">
                  <div className="flex h-28 w-28 items-center justify-center rounded-2xl border border-border bg-white md:h-36 md:w-36">
                    <i className={`${step.icon} text-[42px] text-primary/70 md:text-[52px]`} />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 md:mt-24 border-t border-border pt-12 md:pt-16">
            <div className="text-center mb-10">
              <h2 className="text-[22px] font-semibold tracking-tight md:text-[28px]">
                {t('howItWorksPage.faq.title')}
              </h2>
              <p className="mt-2 text-[15px] text-muted">
                {t('howItWorksPage.faq.subtitle')}
              </p>
            </div>
            <div className="grid gap-4 md:grid-cols-2">
              {faqOrder.map((n) => (
                <div
                  key={n}
                  className="rounded-xl border border-border bg-white p-5"
                >
                  <h3 className="text-[15px] font-semibold text-ink mb-2">
                    {t(`howItWorksPage.faq.q${n}`)}
                  </h3>
                  <p className="text-[14px] leading-relaxed text-muted">
                    {t(`howItWorksPage.faq.a${n}`)}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-14 text-center">
            <a
              href="/#countries"
              className="inline-flex items-center justify-center rounded-md bg-primary px-7 py-3.5 text-[15px] font-semibold text-white transition hover:bg-primary-hover cursor-pointer whitespace-nowrap"
            >
              {t('howItWorksPage.cta')}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
